/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import axios from '@/axios.js'
import _ from "lodash";
import cryptoJS from "crypto-js";

export default {
  loginAttempt({ dispatch }, payload) {

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {

      // Change firebase Persistence
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

        // If success try to login
        .then(function () {
          dispatch('login', newPayload)
        })

        // If error notify
        .catch(function (err) {

          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    } else {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('userRole');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('licenseAgreed');
      router.push('/login').catch(() => {})
      commit('logOut')
      resolve(true);
    });

  },
  login({ commit, state, dispatch }, payload) {
    // If user is already logged in notify and exit
    localStorage.removeItem('adminUser');
    localStorage.removeItem('ViewAsCustomer');   
    if (payload.checkbox_remember_me) {
      const encryptedPwd = cryptoJS.AES.encrypt(payload.userDetails.password, "FV$HSEDEEPV@JUG").toString();     
      document.cookie = "email=" +payload.userDetails.email;
      document.cookie = "server_Js=" +encryptedPwd;
    } else {
      document.cookie = "email=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "server_Js=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }   

    //let postData = { email: payload.userDetails.email, pwd: payload.userDetails.password, code: payload.userDetails.code ,  verificationCode: payload.userDetails.verificationCode};
    let postData = { email: payload.userDetails.email, pwd: payload.userDetails.password};
   

    
    if(_.has(payload.userDetails ,'inactiveVerifyCode' ) && payload.userDetails['inactiveVerifyCode'] ){
      postData['inactiveVerifyCode'] = payload.userDetails['inactiveVerifyCode'];

    }

    if(_.has(payload.userDetails ,'resendVerifyCode' ) && payload.userDetails['resendVerifyCode'] ){
      postData['resendVerifyCode'] = payload.userDetails['resendVerifyCode'];

    }

    if(_.has(payload.userDetails ,'code' ) && payload.userDetails['code'] ){
      postData['code'] = payload.userDetails['code'];

    }
    
    return new Promise((resolve, reject) => {
      axios.post('/auth/login',postData )
        .then((response) => {
          if (response.data.result && response.data.result.code && response.data.result.code == "VERIFY_INAVTIVITY_CODE") {

            resolve(response.data.result);

          }else if (response.data.result && response.data.result.code && response.data.result.code == "VERIFY_2FA_CODE") {

            resolve(response.data.result);

          } else {

            const token = response.data.result.data.accessToken
            const userRole = response.data.result.data.loginRoleId
            const user = response.data.result.data
            
            localStorage.setItem('userRole', userRole)
            localStorage.setItem('token', token)
            localStorage.setItem('user', JSON.stringify(user))

            let licenseAgreed = true;
            if (user.roleId == 2) {
              licenseAgreed = user['licenseAgreed'];
            }
            localStorage.setItem('licenseAgreed', licenseAgreed);
            axios.defaults.headers.common['Authorization'] = token;
            commit('auth_success', { token: token, user: user, userRole: userRole });
            commit('license_agree', { licenseAgreed: licenseAgreed });
            resolve(response.data.result)

          }
        })
        .catch((error) => {

          reject(error.response.data.result.error_message.message)
        }
        )
    })


  },

  get_users_list({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },

  // Google Login
  loginWithGoogle({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.GoogleAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Facebook Login
  loginWithFacebook({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.FacebookAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Twitter Login
  loginWithTwitter({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.TwitterAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Github Login
  loginWithGithub({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.GithubAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  registerUser({ dispatch }, payload) {

    // create user using firebase
    firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
      .then(() => {
        payload.notify({
          title: 'Account Created',
          text: 'You are successfully registered!',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })

        const newPayload = {
          userDetails: payload.userDetails,
          notify: payload.notify,
          updateUsername: true
        }
        dispatch('login', newPayload)
      }, (error) => {
        payload.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  updateUsername({ commit }, payload) {
    payload.user.updateProfile({
      displayName: payload.displayName
    }).then(() => {

      // If username update is success
      // update in localstorage
      const newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      commit('UPDATE_USER_INFO', newUserData, { root: true })

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },



  // JWT
  loginJWT({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {

          // If there's user data in response
          if (response.data.userData) {
            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')

            // Set accessToken
            localStorage.setItem('accessToken', response.data.accessToken)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.userData, { root: true })

            // Set bearer token in axios
            commit('SET_BEARER', response.data.accessToken)

            resolve(response)
          } else {
            reject({ message: 'Wrong Email or Password' })
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/users/register', payload.userDetails)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  updateStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/users/update-status', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
        
          reject(error.response.data.result.error_message.message)
        }
        )
    })
  },
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  },
  forgotPassword({ commit }, payload) {

    return new Promise((resolve, reject) => {


      axios.post('/auth/forgot-password', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {

          reject(error.response.data.result.error_message)
        }
        )
    })
  },
  resetPassword({ commit }, payload) {

    return new Promise((resolve, reject) => {


      axios.post('/auth/update-password', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {

          reject(error.response.data.result.error_message);
        }
        )
    })
  },

  forgotTwoFa({ commit }, payload) {

    return new Promise((resolve, reject) => {


      axios.post('/auth/forgot-2fa', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {

          reject(error.response.data.result.error_message)
        }
        )
    })
  },

  resetTwoFa({ commit }, payload) {

    return new Promise((resolve, reject) => {


      axios.post('/auth/reset-2fa', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {

          reject(error.response.data.result.error_message);
        }
        )
    })
  },


  //viewAsCustomer
  viewAsCustomer({ commit }, customerData) {
    ///auth/switch-account,

    return new Promise((resolve, reject) => {
      axios.post('/auth/switch-account', { email: customerData.email, _id: customerData['_id'] })
        .then((response) => {

          commit('setViewAsCustomer', customerData);
          commit('setAdminUser', JSON.parse(localStorage.getItem('user')));

          const token = response.data.result.data.accessToken
          const userRole = response.data.result.data.loginRoleId
          const user = response.data.result.data
          localStorage.setItem('userRole', userRole)
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          axios.defaults.headers.common['Authorization'] = token;
          commit('auth_success', { token: token, user: user, userRole: userRole })
          commit('license_agree', { licenseAgreed: true });
          localStorage.setItem('licenseAgreed', true);
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message.message)
        }
        )
    })

  },
  //auth/switch-account
  switchAccountBack({ commit }, adminData) {
    ///auth/switch-account,

    return new Promise((resolve, reject) => {
      axios.post('/auth/switch-account', adminData)
        .then((response) => {


          localStorage.setItem('user', JSON.stringify(localStorage.getItem('adminUser')))
          const token = response.data.result.data.accessToken
          const userRole = response.data.result.data.loginRoleId
          const user = response.data.result.data
          localStorage.setItem('userRole', userRole)
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          axios.defaults.headers.common['Authorization'] = token;
          commit('auth_success', { token: token, user: user, userRole: userRole })
          commit('license_agree', { licenseAgreed: true });
          localStorage.setItem('licenseAgreed', true);
          commit('setViewAsCustomer', null);
          commit('setAdminUser', null);
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message.message)
        }
        )
    })

  },
  ///license-agreement/get-recent,
  acceptLicenceAgreement({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/users/license-agree', payload)
        .then(response => {
          localStorage.setItem('licenseAgreed', true);
          commit('license_agree', { licenseAgreed: true });
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },
  //sdk/track-clicks,
  trackClicks({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/track-clicks', payload)
        .then(response => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },

  //auth/setup-2fa,
  setupTwofactor({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/setup-2fa', payload)
        .then(response => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },
  //auth/verify-2fa,
  loginTwoFactor({ commit, state, dispatch }, data) {

    // If user is already logged in notify and exit
    localStorage.removeItem('adminUser');
    localStorage.removeItem('ViewAsCustomer');

    path = '/auth/verify-2fa'
    payload = { email: data.userDetails.email, pwd: data.userDetails.password, code: data.userDetails.code };



    return new Promise((resolve, reject) => {
      axios.post(path, payload)
        .then((response) => {

          const token = response.data.result.data.accessToken
          const userRole = response.data.result.data.loginRoleId
          const user = response.data.result.data
          localStorage.setItem('userRole', userRole)
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))

          let licenseAgreed = true;
          if (user.roleId == 2) {
            licenseAgreed = user['licenseAgreed'];
          }
          localStorage.setItem('licenseAgreed', licenseAgreed);


          axios.defaults.headers.common['Authorization'] = token;
          commit('auth_success', { token: token, user: user, userRole: userRole });
          commit('license_agree', { licenseAgreed: licenseAgreed });
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message.message)
        }
        )
    })


  },

    //Check for two Factor Authentication,
  checkfortwoFactor({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/check-2fa-setup', payload)
        .then(response => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        })
    })
  },

  authAlways({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/always-authenticate', payload)
        .then(response => {
          let twoFactor = false;
          commit('two_factor', { twoFactor: twoFactor });
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        })
    })
  },
  updateUserState({ commit } ,userData){
    commit('updateUserState', userData);
  }


}
